import hiringEasteregg from '~~/common/js/client/hiring-easteregg';

export default ({ isDev }) => {
  if (!isDev) {
    hiringEasteregg();
  }
};
